export function constObjectValues<T extends Record<string, string>>(
  obj: T,
): [T[keyof T], ...T[keyof T][]] {
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- Object.values() of non-empty const object is guaranteed non-empty; TS lacks tuple inference for Object.values()
  return Object.values(obj) as [T[keyof T], ...T[keyof T][]];
}

export function constObjectEntries<K extends string, V>(
  obj: Record<K, V>,
): [K, V][] {
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- Object.entries() widens keys to `string`; the caller's key type (e.g. a branded id) is known and safe to recover here
  return Object.entries(obj) as [K, V][];
}
